<template>
  <div class="ouer-transfer" :style="{ height }">
    <div class="ouer-transfer-panel">
      <div class="ouer-transfer-panel__header">
        <span>{{ headers[0] }}</span>
        <span class="extend">{{ selectedSources.length }}/{{ leftContent.length }}</span>
      </div>
      <el-table
        :data="leftContent"
        class="small-padding"
        :height="tableHeight"
        header-cell-class-name="ouer-transfer__header small-padding"
        @selection-change="handleLeftSelection"
      >
        <el-table-column type="selection" width="40" align="center" />
        <el-table-column
          v-for="(item, index) in leftProps.label"
          :key="index"
          :prop="leftProps.prop[index]"
          show-overflow-tooltip
        >
          <template slot="header">
            <el-input v-if="leftProps.label[index].type === 'search'" v-model="leftSearch" class="ouer-table-search" size="mini" prefix-icon="el-icon-search" placeholder="输入关键字搜索" />
            <span v-else>{{ leftProps.label[index].text }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="ouer-transfer-buttons">
      <el-button type="primary" size="medium" @click.stop="handleMoveToRight">
        {{ buttonTexts && buttonTexts.length ? buttonTexts[0] : '' }}
        <i :class="device==='mobile' ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" />
      </el-button>

      <el-button type="primary" size="medium" @click.stop="handleMoveToLeft">
        <i :class="device==='mobile' ? 'el-icon-arrow-up' : 'el-icon-arrow-left'" />
        {{ buttonTexts && buttonTexts.length ? buttonTexts[1] : '' }}
      </el-button>
    </div>
    <div class="ouer-transfer-panel">
      <div class="ouer-transfer-panel__header">
        <span>{{ headers[1] }}</span>
        <span class="extend">{{ selectedTargets.length }}/{{ selectedData.length }}</span>
      </div>
      <el-table :data="selectedData" class="small-padding" :height="tableHeight" header-cell-class-name="ouer-transfer__header small-padding" @selection-change="handleRightSelection">
        <el-table-column type="selection" width="40" align="center" />
        <el-table-column
          v-for="(item, index) in rightProps.label"
          :key="index"
          :label="rightProps.label[index]"
          :align="rightProps.prop[index].align || 'left'"
          :width="rightProps.prop[index].width || 'auto'"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <template v-if="rightProps.prop[index].type === 'switch'">
              <el-switch v-model="row[rightProps.prop[index].text]" class="rectangle md" :active-value="1" :inactive-value="0" />
            </template>
            <template v-else>{{ row[rightProps.prop[index].text] }}</template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  emits: ['moveToLeft', 'moveToRight'],
  props: {
    height: {
      type: String,
      default: '200px'
    },
    buttonTexts: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => ['Source', 'Target']
    },
    data: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    leftProps: {
      type: Object,
      default() {
        return { label: [], prop: [], key: '' }
      }
    },
    rightProps: {
      type: Object,
      default() {
        return {
          key: '',
          label: [],
          prop: [{}]
        }
      }
    }
  },
  data() {
    return {
      leftSearch: '',
      selectedSources: [],
      selectedTargets: []
    }
  },
  computed: {
    ...mapGetters(['device']),
    leftContent() {
      const unchecked = [...this.data]
      this.value.forEach(item => {
        const index = unchecked.findIndex(source => source[this.leftProps.key] === item[this.rightProps.key])
        if (index >= 0) unchecked.splice(index, 1)
      })
      return !this.leftSearch ? unchecked : unchecked.filter(item => item[this.leftProps.searchKey].toLowerCase().indexOf(this.leftSearch.toLowerCase()) >= 0)
    },
    selectedData: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    },
    tableHeight() {
      const height = parseInt(this.height)
      return height - 40
    }
  },
  methods: {
    handleLeftSelection(val) {
      this.selectedSources = [...val]
    },
    handleRightSelection(val) {
      this.selectedTargets = [...val]
    },
    handleMoveToRight() {
      this.$emit('moveToRight', this.selectedSources)
    },
    handleMoveToLeft() {
      this.$emit('moveToLeft', this.selectedTargets)
    }
  }
}
</script>

<style lang="scss" scoped>
.ouer-transfer {
  width: 100%;
  display: flex;
  font-size: 14px;
  .ouer-transfer-panel {
    position: relative;
    display: inline-block;
    flex: 1;
    max-height: 100%;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    .ouer-transfer-panel__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      padding-left: 15px;
      padding-right: 15px;
      font-size: 16px;
      color: #303133;
      font-weight: 400;
      background-color: #f5f7fa;
      border-bottom: 1px solid #ebeef5;
      .extend {
        font-size: 12px;
        font-weight: 400;
        color: #909399;
      }
    }
  }
  .ouer-transfer-buttons {
    display: flex;
    padding: 30px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .el-button + .el-button {
      margin-left: 0;
      margin-top: 10px;
    }
    .el-button [class^=el-icon-] {
      font-weight: 600;
    }
  }
  .el-table::v-deep {
    th.el-table__cell {
      &.ouer-transfer__header {
        color: #303133;
        // background-color: #f5f7fa;
      }
      &.is-leaf {
        border: 0;
      }
    }
    td.el-table__cell {
      border: 0;
      cursor: pointer;
    }
    .ouer-table-search .el-input__inner {
      border-radius: 20px;
    }
  }
}
@media screen and (max-width: 992px) {
  .ouer-transfer {
    flex-direction: column;
    .ouer-transfer-buttons {
      flex-direction: row;
      .el-button--medium {
        padding: 10px;
        width: 36px;
        display: inline-flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        white-space: normal;
      }
      .el-button + .el-button {
        margin-left: 10px;
        margin-top: 0;
      }
    }
  }
}
</style>
